import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card card-flush pt-3 mb-5 mb-lg-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#performance-report",
  "aria-expanded": "true",
  "aria-controls": "performance-report"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Parametreler - Sevk Raporu")
  ])
], -1)
const _hoisted_3 = {
  id: "performance-report",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body p-9" }
const _hoisted_5 = { class: "row g-12 mb-8" }
const _hoisted_6 = { class: "col-md-4 fv-row" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Sevk Tarihi 1", -1)
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Sevk Tarihi 2", -1)
const _hoisted_12 = { class: "col-md-4 fv-row" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Müşteri", -1)
const _hoisted_14 = { class: "position-relative align-items-center" }
const _hoisted_15 = { class: "col-md-4 fv-row" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Sezon", -1)
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Sipariş Şekli", -1)
const _hoisted_21 = { class: "row g-12 mb-8" }
const _hoisted_22 = { class: "col-md-4 fv-row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Üretici", -1)
const _hoisted_24 = { class: "position-relative align-items-center" }
const _hoisted_25 = { class: "col-md-4 fv-row" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Departman", -1)
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Marka", -1)
const _hoisted_31 = { class: "col-md-4 fv-row" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Artikel", -1)
const _hoisted_33 = { class: "position-relative align-items-center" }
const _hoisted_34 = { class: "row g-12 mb-8" }
const _hoisted_35 = { class: "col-md-4 fv-row" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Order", -1)
const _hoisted_37 = { class: "position-relative align-items-center" }
const _hoisted_38 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_39 = {
  key: 0,
  class: "card card-flush pt-3 mb-5 mb-lg-10"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Sevk Raporu")
  ])
], -1)
const _hoisted_41 = { class: "card-body" }
const _hoisted_42 = { class: "row" }
const _hoisted_43 = { class: "col-md-12" }
const _hoisted_44 = { class: "table-responsive" }
const _hoisted_45 = { style: {"text-align":"left"} }
const _hoisted_46 = { class: "image-text" }
const _hoisted_47 = { class: "image-text" }
const _hoisted_48 = { class: "image-text" }
const _hoisted_49 = { class: "image-text" }
const _hoisted_50 = { class: "image-text" }
const _hoisted_51 = { class: "image-text" }
const _hoisted_52 = { class: "image-text" }
const _hoisted_53 = { class: "image-text" }
const _hoisted_54 = { class: "image-text" }

import { defineComponent, ref, computed } from "vue";

import Breadcrumb from "primevue/breadcrumb";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import Department from "@/components/departments/Department.vue";
import DepartmentMultiSelect from "@/components/departments/DepartmentMultiSelect.vue";
import SeasonMultiSelect from "@/components/seasons/SeasonMultiSelect.vue";
import Customer from "@/components/customers/CustomerSingleSelect.vue";
import Supplier from "@/components/suppliers/SupplierSingleSelect.vue";
import Season from "@/components/seasons/Season.vue";
import OrderTypeMultiSelect from "@/components/orderTypes/OrderTypeMultiSelect.vue";
import BrandMultiSelect from "@/components/brands/BrandMultiSelect.vue";

import CustomerMultiSelect from "@/components/customers/CustomerMultiSelect.vue";
import SupplierMultiSelect from "@/components/suppliers/SupplierMultiSelect.vue";
import PrintReport from "./components/print-shipping-report.vue";
import moment from "moment";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import useNotification from "@/components/useNotification";
import { useRouter, useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const notification = useNotification();
//import { components } from "@/assets/ts";
const router = useRouter();
const store = useStore();
const isActive = ref(false);
const date: any = ref();
const customers: any = ref();
const suppliers: any = ref();
const departmentId: any = ref();
const seasonIds: any = ref();

const symbol: any = ref();
const deliveryDate: any = ref();
const deliveryDateOne: any = ref();
const deliveryDateTwo: any = ref();

const orderDate: any = ref();
const order = ref();
const toggleModal = () => {
  isActive.value = !isActive.value;
};
const filters = ref({
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  orderId: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  orderQuantity: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
  },
  deliveryDate: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  shippingDate: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  customerName: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  brandName: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  articleNumber: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  department: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  seasonName: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  order: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  orderTypeName: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  supplierName: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  modelCode: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
});
const selectedCustomer = (args) => {
  customers.value = args.value;
};
const selectedDepartment = (args) => {
  departmentId.value = args.value;
};
const selectedSupplier = (args) => {
  suppliers.value = args.value;
};
const selectedSeason = (args) => {
  if (args.value) {
    seasonIds.value = args.value;
  } else {
    seasonIds.value = [];
  }
};
const selectedYear = (args) => {
  date.value = args.value;
};

const deliveryReportList = computed(
  () => store.state.ReportModule.deliveryReport.value || []
);

const send = () => {
  if (!deliveryDateOne.value) {
    notification.showError("Sevk Tarihi 1 Zorunlu");
    return;
  }
  if (!deliveryDateTwo.value) {
    notification.showError("Sevk Tarihi 2 Zorunlu");
    return;
  }
  store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
  let model = {
    deliveryDateOne: deliveryDateOne.value,
    deliveryDateTwo: deliveryDateTwo.value,
    customerIds: customers.value ? customers.value.map((f) => f.id) : [],
    supplierIds: suppliers.value ? suppliers.value.map((f) => f.id) : [],
    departmentIds: departmentId.value
      ? departmentId.value.map((f) => f.value)
      : [],
    seasonIds: seasonIds.value ? seasonIds.value.map((f) => f.value) : [],
    currencyTypeId: 1,
    articleNumber: articleNumber.value,
    order: order.value,
    brandIds: brandIds.value || [],
    orderTypeIds: orderTypeIds.value || [],
  };
  symbol.value = model.currencyTypeId == 1 ? "€" : "$";
  store.dispatch(Actions.DELIVERY_REPORT_LIST, model).then(() => {
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
  });
};
const filteredData = ref();
const filterData = (data) => {
  filteredData.value = data;
};
const exportExcel = () => {
  import("xlsx").then((xlsx) => {
    const data = filteredData.value.map((x) => {
      return {
        "Sipariş Numarası": x.orderId,
        Müşteri: x.customerName,
        Marka: x.brandName,
        Departman: x.department,
        Üretici: x.supplierName,
        "Model Kodu": x.modelCode,
        Artikel: x.articleNumber,
        Order: x.order,
        "Sipariş Şekli": x.orderTypeName,
        Sezon: x.seasonName,
        "Yükleme Tarihi": moment(x.shippingDate).format("DD.MM.YYYY"),
        "Sevk Tarihi": moment(x.deliveryDate).format("DD.MM.YYYY"),
        "Sipariş Adedi": x.orderQuantity,
        Fiyat:
          x.orderLinePrice
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
            .replace(/\.(\d+)$/, ",$1")
            .toString() +
          " " +
          (symbol.value == null ? " €" : symbol.value),
        "Toplam Fiyat":
          (x.orderLinePrice * x.orderQuantity)
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
            .replace(/\.(\d+)$/, ",$1")
            .toString() +
          " " +
          (symbol.value == null ? " €" : symbol.value),
        "Sevk Edilen": x.shipped,
        "Sevk Tutarı":
          x.deliveryTotalPrice
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
            .replace(/\.(\d+)$/, ",$1")
            .toString() +
          " " +
          (symbol.value == null ? " €" : symbol.value),
      };
    });

    const ws = xlsx.utils.json_to_sheet(data);
    const wb = xlsx.utils.book_new();

    //  ws.s = { // styling for all cells
    //         alignment: {
    //             vertical: "right",
    //             horizontal: "right",
    //             wrapText: '1', // any truthy value here
    //         },
    //         border: {
    //             right: {
    //                 style: "thin",
    //                 color: "0000FF"
    //             },
    //             left: {
    //                 style: "thin",
    //                 color: "0000FF"
    //             },
    //         }
    //     };
    xlsx.utils.book_append_sheet(wb, ws, "sheet01");

    //    ws.utils.getCell('K2').numFmt = '0.00%';
    //  ws['K6'] = { f: 'SUM(K2:K5)' };
    //    ws['J6'] = { v: 'Toplam' };
    xlsx.utils.sheet_add_aoa(
      ws,
      [
        [
          "Toplam",
          filteredData.value
            .map((f) => f.orderQuantity)
            .reduce(function (a, b) {
              return a + b;
            }, 0),
          "",
          filteredData.value
            .map((f) => f.orderQuantity * f.orderLinePrice)
            .reduce(function (a, b) {
              return a + b;
            }, 0)
            .toFixed(2),
          filteredData.value
            .map((f) => f.shipped)
            .reduce(function (a, b) {
              return a + b;
            }, 0),
          filteredData.value
            .map((f) => f.deliveryTotalPrice)
            .reduce(function (a, b) {
              return a + b;
            }, 0)
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
            .replace(/\.(\d+)$/, ",$1") +
            " " +
            (symbol.value == null ? " €" : symbol.value),
        ],
      ],
      { origin: "L" }
    );

    const fileName = `shipping_report_${moment(new Date()).format()}.xlsx`;

    xlsx.writeFile(wb, fileName);
  });
};
const filterDataList = computed(() => filteredData.value || []);
const totalPrice = () => {
  var response = filterDataList.value
    .map((f) => f.totalPrice)
    .reduce(function (a, b) {
      return a + b;
    }, 0)
    .toFixed(2)
    .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
    .replace(/\.(\d+)$/, ",$1")
    .toString();

  return response;
};
const deliveryTotalPrice = () => {
  var response = filterDataList.value
    .map((f) => f.deliveryTotalPrice)
    .reduce(function (a, b) {
      return a + b;
    }, 0)
    .toFixed(2)
    .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
    .replace(/\.(\d+)$/, ",$1")
    .toString();

  return response;
};

const totalOrderPrice = () => {
  var response = filterDataList.value
    .map((f) => f.orderLinePrice * f.orderQuantity)
    .reduce(function (a, b) {
      return a + b;
    }, 0)
    .toFixed(2)
    .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
    .replace(/\.(\d+)$/, ",$1")
    .toString();

  return response;
};
const articleNumber = ref();

const clearFilter1 = () => {
  initFilters1();
};
const initFilters1 = () => {
  filters.value = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    orderId: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    orderQuantity: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    deliveryDate: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    shippingDate: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    customerName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    brandName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    articleNumber: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    department: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    seasonName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    order: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    orderTypeName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    supplierName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    modelCode: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
  };
};

// Marka ve Sipariş Şekli için değişkenler ve fonksiyonlar ekleyelim
const brandIds = ref([]);
const orderTypeIds = ref([]);

const selectedBrand = (args) => {
  if (args.value && args.value.length > 0) {
    brandIds.value = args.value.map((item) => item.value);
  } else {
    brandIds.value = [];
  }
};

const selectedOrderType = (args) => {
  if (args.value && args.value.length > 0) {
    orderTypeIds.value = args.value.map((item) => item.value);
  } else {
    orderTypeIds.value = [];
  }
};

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Row = _resolveComponent("Row")!
  const _component_ColumnGroup = _resolveComponent("ColumnGroup")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "p-inputtext p-component p-filled col-md-12 col-md-12",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((deliveryDateOne).value = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, deliveryDateOne.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "p-inputtext p-component p-filled col-md-12 col-md-12",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((deliveryDateTwo).value = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, deliveryDateTwo.value]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createVNode(CustomerMultiSelect, { onChangeCustomer: selectedCustomer })
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(SeasonMultiSelect, {
                    class: "col-md-12",
                    onChangeSeason: selectedSeason
                  })
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode(OrderTypeMultiSelect, {
                    class: "col-md-12",
                    onChangeOrderType: selectedOrderType
                  })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _createVNode(SupplierMultiSelect, {
                  class: "col-md-12",
                  onChangeSupplier: selectedSupplier
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createVNode(DepartmentMultiSelect, {
                    class: "col-md-12",
                    onChangeDepartment: selectedDepartment
                  })
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createVNode(BrandMultiSelect, {
                    class: "col-md-12",
                    onChangeBrand: selectedBrand
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_component_InputText, {
                  type: "text",
                  modelValue: articleNumber.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((articleNumber).value = $event)),
                  class: "col-md-12"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("div", _hoisted_37, [
                _createVNode(_component_InputText, {
                  type: "text",
                  modelValue: order.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((order).value = $event)),
                  class: "col-md-12"
                }, null, 8, ["modelValue"])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("button", {
          id: "performance-report_submit",
          ref: "submitButtonSettings",
          class: "btn btn-primary",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (send()))
        }, " Görüntüle ", 512)
      ])
    ]),
    (_unref(deliveryReportList).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
          _hoisted_40,
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createVNode(_component_DataTable, {
                    showGridlines: "",
                    onValueChange: filterData,
                    removableSort: "",
                    value: _unref(store).state.ReportModule.deliveryReport.value,
                    class: "p-datatable-sm",
                    responsiveLayout: "scroll",
                    filters: filters.value,
                    "onUpdate:filters": _cache[7] || (_cache[7] = ($event: any) => ((filters).value = $event)),
                    stripedRows: "",
                    filterDisplay: "menu",
                    dataKey: "id",
                    paginator: true,
                    rows: 56,
                    style: {"width":"max-content","min-width":"-webkit-fill-available","font-size":"11px","max-width":"90% !important","font-weight":"bold"}
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_45, [
                        _createVNode(_component_Button, {
                          icon: "pi pi-print",
                          class: "p-button-rounded btn btn-primary",
                          style: {"padding":"0","margin-right":"5px"},
                          onClick: toggleModal
                        }),
                        _createVNode(_component_Button, {
                          icon: "pi pi-file-excel",
                          class: "p-button-rounded btn btn-primary",
                          style: {"padding":"0"},
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (exportExcel()))
                        }),
                        _createVNode(_component_Button, {
                          type: "button",
                          icon: "pi pi-filter-slash",
                          label: "Temizle",
                          class: "p-button-outlined",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (clearFilter1())),
                          style: {"margin-left":"10px"}
                        })
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        field: "orderId",
                        header: "Sipariş No",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"6rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_46, _toDisplayString(data.orderId), 1)
                        ]),
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            class: "p-column-filter",
                            placeholder: "Sipariş Numarası Ara...    "
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "customerName",
                        header: "Müşteri",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_47, _toDisplayString(data.customerName), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "brandName",
                        header: "Marka",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_48, _toDisplayString(data.brandName), 1)
                        ]),
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            class: "p-column-filter",
                            placeholder: "Marka içinde ara.."
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "department",
                        header: "Departman",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"8rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_49, _toDisplayString(data.department), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "supplierName",
                        header: "Üretici",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_50, _toDisplayString(data.supplierName), 1)
                        ]),
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            class: "p-column-filter",
                            placeholder: "Üretici içinde ara.."
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "modelCode",
                        header: "Model Kodu",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"6rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_51, _toDisplayString(data.modelCode), 1)
                        ]),
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            class: "p-column-filter",
                            placeholder: "Miktar İçinde Ara"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "articleNumber",
                        header: "Artikel",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"3rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_52, _toDisplayString(data.articleNumber), 1)
                        ]),
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            class: "p-column-filter",
                            placeholder: "Artikel içinde ara.."
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "order",
                        header: "Order",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"5rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_53, _toDisplayString(data.order), 1)
                        ]),
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            class: "p-column-filter",
                            placeholder: "Order içinde ara.."
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "orderTypeName",
                        header: "Sipariş Şekli",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"5rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_54, _toDisplayString(data.orderTypeName), 1)
                        ]),
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            class: "p-column-filter",
                            placeholder: "Sipariş Şekli içinde ara.."
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "seasonName",
                        header: "Sezon",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(data.seasonName), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "shippingDate",
                        header: "Yükleme Tarihi",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(_unref(moment)(data.shippingDate).format("DD.MM.YYYY")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "deliveryDate",
                        header: "Sevk Tarihi",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(_unref(moment)(data.deliveryDate).format("DD.MM.YYYY")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "orderQuantity",
                        header: "Sipariş Adedi",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"},
                        class: "text-end"
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(data.orderQuantity), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "orderLinePrice",
                        header: "Fiyat",
                        sortable: "",
                        filterMatchMode: "contains",
                        class: "text-end",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(parseFloat(data.orderLinePrice)
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                        .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(symbol.value == null ? "€" : symbol.value), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "shipped",
                        header: "Top. Tutar",
                        sortable: "",
                        filterMatchMode: "contains",
                        class: "text-end",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString((parseFloat(data.orderLinePrice) * data.orderQuantity)
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                        .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(symbol.value == null ? "€" : symbol.value), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "shipped",
                        header: "Sevk Edilen",
                        sortable: "",
                        filterMatchMode: "contains",
                        class: "text-end",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(data.shipped), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "deliveryTotalPrice",
                        header: "Sevk Tutarı",
                        sortable: "",
                        filterMatchMode: "contains",
                        class: "text-end",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(parseFloat(data.deliveryTotalPrice)
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                        .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(symbol.value == null ? "€" : symbol.value), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ColumnGroup, { type: "footer" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Column, {
                                footer: "",
                                colspan: 12,
                                footerStyle: "text-align:right"
                              }),
                              _createVNode(_component_Column, {
                                footer: 
                      _unref(filterDataList)
                        .map((f) => f.orderQuantity)
                        .reduce(function (a, b) {
                          return a + b;
                        }, 0)
                    ,
                                class: "text-end"
                              }, null, 8, ["footer"]),
                              _createVNode(_component_Column, {
                                footer: "",
                                colspan: 1,
                                footerStyle: "text-align:right"
                              }),
                              _createVNode(_component_Column, {
                                footer: 
                      totalOrderPrice() + (symbol.value == null ? ' €' : symbol.value)
                    ,
                                class: "text-end"
                              }, null, 8, ["footer"]),
                              _createVNode(_component_Column, {
                                footer: 
                      _unref(filterDataList)
                        .map((f) => f.shipped)
                        .reduce(function (a, b) {
                          return a + b;
                        }, 0)
                    ,
                                class: "text-end"
                              }, null, 8, ["footer"]),
                              _createVNode(_component_Column, {
                                footer: 
                      deliveryTotalPrice() + (symbol.value == null ? ' €' : symbol.value)
                    ,
                                class: "text-end"
                              }, null, 8, ["footer"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "filters"])
                ])
              ])
            ])
          ]),
          (isActive.value)
            ? (_openBlock(), _createBlock(PrintReport, {
                key: 0,
                isActive: isActive.value,
                data: filteredData.value,
                currencyType: symbol.value == null ? ' €' : symbol.value,
                onChangeReceipt: toggleModal
              }, null, 8, ["isActive", "data", "currencyType"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})